
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/band-9-IELTS-speaking",
      function () {
        return require("private-next-pages/elearning/band-9-IELTS-speaking.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/band-9-IELTS-speaking"])
      });
    }
  